import * as React from 'react';

import {SelectPickerSearch} from '../select-picker-search/select-picker-search';

import {ChannelIconWithName} from './channel-icon-with-name';
import {getChannelSelectOptions} from './helpers';
import type {ChannelType, ChannelOption} from './types';

type Props = {
    channelSelection?: ChannelType | null | undefined;
    onSelectChannel: (channel: ChannelType) => void;
    onBlur?: () => void;
    autoFocus?: boolean;
    existingChannels?: ChannelType[];
    includeNoChannelOption?: boolean;
    minHeight?: number;
    preventScrollOnMenuOpen?: boolean;
    menuZIndex?: number;
};

export function ChannelPicker(props: Props) {
    const {autoFocus = true, minHeight = 34, preventScrollOnMenuOpen = true} = props;
    const channelOptions = getChannelSelectOptions(
        props.existingChannels,
        props.includeNoChannelOption
    );

    return (
        <SelectPickerSearch
            minHeight={minHeight}
            noPadding={true}
            placeholder='Search channels…'
            autoFocus={autoFocus}
            openMenuOnFocus={true}
            preventScrollOnMenuOpen={preventScrollOnMenuOpen}
            options={channelOptions}
            onBlur={props.onBlur}
            value={
                props.channelSelection
                    ? channelOptions.find((option) => option.value === props.channelSelection)
                    : undefined
            }
            // @ts-expect-error
            onChange={(channelOption) => {
                if (channelOption && !Array.isArray(channelOption)) {
                    props.onSelectChannel(channelOption.value);
                }
            }}
            formatOptionLabel={(option: ChannelOption) => (
                <ChannelIconWithName channel={option.value} isSmall={true} />
            )}
            menuZIndex={props.menuZIndex}
        />
    );
}
